import type { IContinueWatchProgressBar } from './ContinueWatchProgressBar.h'

import { styled } from '@linaria/react'
import { FIXED_INDENTS } from 'vars/fixed-indents'
import { MEDIA } from 'vars/media'

export const ContinueWatchProgressBarSC = styled.div<
  Pick<IContinueWatchProgressBar, 'width'>
>`
  --continueWatchProgressMaxWidth: 360px;

  display: grid;
  gap: var(${FIXED_INDENTS.INDENT_20});
  width: ${({ width }) => width || '100%'};
  max-width: 100%;

  ${MEDIA.MIN_600} {
    max-width: var(--continueWatchProgressMaxWidth);
  }
`
